<template>
  <div class="filterBase">
    <div
      :class="['filter', 'filter--' + value.type, disabled ? 'filter--disabled' : '']"
      :content="tooltipText"
      @mouseover="setTooltipText('base')"
      v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
    >
      <div
        :class="['filter__icon', 'filter__icon--' + getFilterIconSize(value.type)]"
        v-html="getFilterIcon(value.type)"
      />

      <div
        class="filter__symbol"
        v-html="value.type === 'queries' ? '' : getConditionSymbol(value.attributes.condition)"
      />

      <div
        class="filter__text"
        v-html="decodeURIComponent(capitalizeText(value.attributes.name))"
      />

      <div
        v-if="noRemoval === false"
        class="filter__close"
        @mouseover.stop="setTooltipText('close')"
        @click="clicked(value)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 15.538l-3.592-3.548 3.546-3.587-1.416-1.403-3.545 3.589-3.588-3.543-1.405 1.405 3.593 3.552-3.547 3.592 1.405 1.405 3.555-3.596 3.591 3.55 1.403-1.416z"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    value: {
      type: [Object, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noRemoval: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tooltipText: ''
    }
  },
  methods: {
    clicked (value) {
      this.$emit('removed', value)
    },
    setTooltipText (method) {
      if (method === 'base') {
        if (!this.disabled) {
          this.tooltipText = this.getFilterName(this.value.type) + ' <u>' + this.getConditionName(this.value.attributes.condition).toLowerCase() + '</u> "' + this.value.attributes.name + '"'
        } else {
          this.tooltipText = this.getFilterName(this.value.type) + ' filter is disabled in <u>' + this.getTypeName(this.getSearchView()).toLowerCase() + '</u> view'
        }
      } else if (method === 'close') {
        if (this.value.type === 'queries') {
          this.tooltipText = 'Remove <u>search</u> query'
        } else {
          this.tooltipText = 'Remove <u>' + this.getFilterName(this.value.type).toLowerCase() + '</u> filter'
        }
      }
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.filterBase {
  background-color: $bg-2;
  margin: 0px 4px;
  border-radius: 999px;
}

.filter {
  @include font('content--md');
  position: relative;
  display: inline-flex;
  align-items: center;
  width: auto;
  max-width: 284px;
  fill: rgba($white, 0.7);
  height: 28px;
  padding: 0 10px;
  margin: 0px;
  border-radius: 999px;
  border: 2px solid $bg-1;
  outline: 0;
  user-select: none;
  transition: fill 0.25s ease-out, color 0.25s ease-out;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg');
    max-width: 300px;
    height: 30px;
    padding: 0px 12px;
    margin: 0px;
  }

  &:hover {
    fill: $white;
    border-color: $bg-1;

    .filter__icon {
      transform: scale(1.2);

      @media screen and (min-width: $breakpointLg) {
        transform: scale(1.175);
      }
    }

    .filter__close {
      opacity: 1;
    }
  }

  &__icon {
    margin-right: 4px;
    transition: fill 0.2s ease-out, transform 0.2s ease-out;

    &--xs {
      min-width: 14px;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 16px;
        width: 16px;
        height: 16px;
      }
    }

    &--sm {
      min-width: 16px;
      width: 16px;
      height: 16px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 18px;
        width: 18px;
        height: 18px;
      }
    }

    &--md {
      min-width: 18px;
      width: 18px;
      height: 18px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 20px;
        width: 20px;
        height: 20px;
      }
    }

    &--lg {
      min-width: 20px;
      width: 20px;
      height: 20px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 22px;
        width: 22px;
        height: 22px;
      }
    }
  }

  &__symbol {
    color: $bg-1;
    font-weight: 500;
    margin-right: 2px;
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__close {
    position: absolute;
    display: inline-flex;
    align-items: center;
    user-select: none;
    right: -2px;
    background-color: $bg-2;
    border: 2px solid $bg-1;
    padding: 4px;
    border-radius: 999px;
    fill: rgba($white, 0.5);
    opacity: 0;
    cursor: pointer;

    &:hover {
      fill: rgba($white, 0.9) !important;

      svg {
        transform: scale(1.2);

        @media screen and (min-width: $breakpointLg) {
          transform: scale(1.175);
        }
      }
    }

    &:active {
      background-color: $bg-1;

      svg {
        fill: $blue;
        transform: scale(1);
      }
    }

    svg {
      transition: fill 0.2s ease-out, transform 0.2s ease-out;
      width: 20px;
      height: 20px;

      @media screen and (min-width: $breakpointLg) {
        width: 22px;
        height: 22px;
      }
    }
  }

  &--disabled {
    fill: rgba($white, 0.5) !important;
    background-color: rgba($white, 0.1) !important;

    &:hover {
      background-color: rgba($white, 0.05) !important;
    }

    .filter__text {
      color: rgba($white, 0.5) !important;
    }
  }

  &--queries {
    fill: $white;
    background-color: rgba($purple, 0.45);

    &:hover {
      background-color: rgba($purple, 0.3);
    }
  }

  &--titles {
    fill: $white;
    background-color: rgba(#DF5D99, 0.45);

    &:hover {
      background-color: rgba(#DF5D99, 0.3);
    }
  }

  &--descriptions {
    fill: $white;
    background-color: rgba(#fa8be2, 0.4);

    &:hover {
      background-color: rgba(#fa8be2, 0.25);
    }
  }

  &--data_series {
    fill: $white;
    background-color: rgba(#487cff, 0.45);

    &:hover {
      background-color: rgba(#487cff, 0.3);
    }
  }

  &--published {
    fill: $white;
    background-color: rgba(#96D1B4, 0.45);

    &:hover {
      background-color: rgba(#96D1B4, 0.3);
    }
  }

  &--topics {
    fill: $white;
    background-color: rgba($blue, 0.45);

    &:hover {
      background-color: rgba($blue, 0.3);
    }
  }

  &--locations {
    fill: $white;
    background-color: rgba($green, 0.45);

    &:hover {
      background-color: rgba($green, 0.3);
    }
  }

  &--trade_types {
    fill: $white;
    background-color: rgba($yellow, 0.55);

    &:hover {
      background-color: rgba($yellow, 0.4);
    }
  }

  &--scales {
    fill: $white;
    background-color: rgba($orange, 0.45);

    &:hover {
      background-color: rgba($orange, 0.3);
    }
  }

  &--providers {
    fill: $white;
    background-color: rgba($pink, 0.45);

    &:hover {
      background-color: rgba($pink, 0.3);
    }
  }
}

</style>
